import { postJsonAsync } from './fetchConfig';

export const postAcceptMissingInfo = (id, values, etag) => postJsonAsync(`organizations/${ id }/accept-missing-info`, values, { headers: { 'If-Match': etag } });
